import {useBackgroundStyleConfigs} from 'hooks/useBackgroundStyleConfigs';

import {useMediaQuery} from '@mui/material';

import {TypoComponentsBenefitsSection} from 'lib/api/strapi';

import {breakpoint} from 'styles/mui/scss';

import {Box, Grid, Typography} from 'components/basic-components';
import {withErrorBoundary} from 'components/error/ErrorBoundary';

import {BenefitsSectionElement} from './BenefitsSectionElement';
import styles from './benefitssection.module.scss';

const hasBottomBorder = (index, elementsLength) => {
  return index !== elementsLength - 1;
};

const hasBorder = (index, columns) => {
  return (index + 1) % columns !== 0;
};

const getColumns = ({
  divisibleBy3,
  divisibleBy4,
  elementsLength,
  isDesktop,
  isTablet,
  isMobile,
}) => {
  if (isDesktop) {
    return divisibleBy4 ? 4 : divisibleBy3 ? 3 : elementsLength > 4 ? 4 : elementsLength;
  }
  if (isTablet) {
    return divisibleBy3 ? 3 : elementsLength > 3 ? 3 : elementsLength;
  }
  if (isMobile) {
    return 2;
  }
  return 1;
};

const BenefitsSection = ({
  headline,
  headerLevel,
  headlineFullWidth,
  elements,
  disableSeperator,
}: TypoComponentsBenefitsSection) => {
  const elementsLength = elements.length;
  const divisibleBy4 = elementsLength % 4 === 0;
  const divisibleBy3 = elementsLength % 3 === 0;
  const isDesktop = useMediaQuery(`(min-width:${breakpoint.xl}px)`);
  const isTablet = useMediaQuery(`(min-width:${breakpoint.md}px)`);
  const isMobile = useMediaQuery(`(min-width:${breakpoint.sm}px)`);
  const columns = getColumns({
    divisibleBy3,
    divisibleBy4,
    elementsLength,
    isDesktop,
    isTablet,
    isMobile,
  });
  const {textColor} = useBackgroundStyleConfigs();

  return (
    <Box className={styles.benefitsSectionWrapper} sx={{color: textColor}}>
      {headline ? (
        <Typography
          className={styles.benefitsSectionHeadline}
          component={headerLevel}
          variant="h2"
          sx={{width: {xxs: '100%', xxl: headlineFullWidth ? '100%' : '50%'}}}
        >
          {headline}
        </Typography>
      ) : null}
      <Grid container spacing="2%" rowSpacing="4%">
        {elements.map((el, index) => (
          <Grid xxs={12 / columns} key={el.id}>
            <BenefitsSectionElement
              {...el}
              borderBottom={disableSeperator ? undefined : hasBottomBorder(index, elementsLength)}
              borderLeft={disableSeperator ? undefined : hasBorder(index, columns)}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default withErrorBoundary(BenefitsSection, ' BenefitsSection');
